<app-announcement-bar></app-announcement-bar>
<app-navbar-user [active]="'dashboard'"></app-navbar-user>
<div class="container-fluid dashboard p-4 main-content">
    <div class="row">
        <div class="col-md-12 mb-3">
            <div class="d-md-flex align-items-center justify-content-between d-block">
                <div class="d-flex align-items-center">
                    <h2 class="m-0 page-title"><i class="bx bx-library btn-icon"></i> Play </h2>
                    <div class="d-sm-block d-md-inline mt-1 mb-3 mt-md-0 mb-md-0">
                    </div>
                </div>
            </div>

            <div>
                <div *ngIf="hash" class="player-wrapper mt-3" style="display: flex;align-items:center;justify-content: center;max-height:75vh;">
                    <iframe [src]="'./loader/' + hash | safe : 'resourceUrl'" frameborder="0" width="100%" height="100%"
                        style="max-height:75vh;margin:0 auto;"></iframe>
                        
                </div>
                
            </div>

            

        </div>
    </div>
</div>
<app-footer></app-footer>